export const PERMISSION_ROLE_LIST_INITING             = 'PERMISSION_ROLE_LIST_INITING'
export const PERMISSION_ROLE_LIST_REQUESTING          = 'PERMISSION_ROLE_LIST_REQUESTING'
export const PERMISSION_ROLE_LIST_SUCCESS             = 'PERMISSION_ROLE_LIST_SUCCESS'
export const PERMISSION_ROLE_LIST_ERROR               = 'PERMISSION_ROLE_LIST_ERROR'   

export const PERMISSION_ROLE_DETAIL_INITING           = 'PERMISSION_ROLE_DETAIL_INITING'
export const PERMISSION_ROLE_DETAIL_REQUESTING        = 'PERMISSION_ROLE_DETAIL_REQUESTING'
export const PERMISSION_ROLE_DETAIL_SUCCESS           = 'PERMISSION_ROLE_DETAIL_SUCCESS'
export const PERMISSION_ROLE_DETAIL_ERROR             = 'PERMISSION_ROLE_DETAIL_ERROR'   

export const PERMISSION_ROLE_UPDATE_REQUESTING        = 'PERMISSION_ROLE_UPDATE_REQUESTING'
export const PERMISSION_ROLE_UPDATE_SUCCESS           = 'PERMISSION_ROLE_UPDATE_SUCCESS'
export const PERMISSION_ROLE_UPDATE_ERROR             = 'PERMISSION_ROLE_UPDATE_ERROR'   

export const PERMISSION_ROLE_DETAIL_API               = '/api/v1/permissionrole/permission_role_list_by_store'  
export const PERMISSION_ROLE_LIST_API                 = '/api/v1/role/roles_list_by_store'   
export const PERMISSION_ROLE_UPDATE_API               = '/api/v1/permissionrole/permission_role_update_by_ids'  


// WEBPACK FOOTER //
// ./src/views/PermissionRole/constants.js